// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"29a366ed","841":"47f7e28c"}[chunkId] + ".chunk.js";
};